import { render, staticRenderFns } from "./advancedSetup.vue?vue&type=template&id=35ae7cbd&scoped=true&"
import script from "./advancedSetup.vue?vue&type=script&lang=js&"
export * from "./advancedSetup.vue?vue&type=script&lang=js&"
import style0 from "./advancedSetup.vue?vue&type=style&index=0&id=35ae7cbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae7cbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ae7cbd')) {
      api.createRecord('35ae7cbd', component.options)
    } else {
      api.reload('35ae7cbd', component.options)
    }
    module.hot.accept("./advancedSetup.vue?vue&type=template&id=35ae7cbd&scoped=true&", function () {
      api.rerender('35ae7cbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/createFlow/components/advancedSetup.vue"
export default component.exports